module.exports = __webpack_public_path__ + "img/image-02.a745dc76.jpg";